/* -------------------------- CARRITO DE MATERIALES ------------------------- */
export const ADD_TO_COSTS_CART = "ADD_TO_COSTS_CART";
export const CHANGE_QUANTITY_COSTS_CART = "CHANGE_QUANTITY_COSTS_CART";
export const SET_DATA_COSTS_CART = "SET_DATA_COSTS_CART";
export const REMOVE_ONE_FROM_COSTS_CART = "REMOVE_ONE_FROM_COSTS_CART";
export const REMOVE_ALL_FROM_COSTS_CART = "REMOVE_ALL_FROM_COSTS_CART";
export const CLEAR_COSTS_CART = "CLEAR_COSTS_CART";
export const CALCULATE_PRICES_COSTS_CART = "CALCULATE_PRICES_COSTS_CART";
export const SET_EXTRAS_TOTAL = "SET_EXTRAS_TOTAL";
export const SET_IVA_MATERIALS = "SET_IVA_MATERIALS";

/* -------------------------- CARRITO DE PERSONAL ------------------------- */
export const ADD_TO_STAFF_CART = "ADD_TO_STAFF_CART";
export const CHANGE_NUMBER_PEOPLE_STAFF_CART = "CHANGE_NUMBER_PEOPLE_STAFF_CART";
export const CHANGE_DURATION_STAFF_CART = "CHANGE_DURATION_STAFF_CART";
export const CHANGE_SURCHARGE_STAFF_CART = "CHANGE_SURCHARGE_STAFF_CART";
export const SET_DATA_STAFF_CART = "SET_DATA_STAFF_CART";
export const REMOVE_ONE_FROM_STAFF_CART = "REMOVE_ONE_FROM_STAFF_CART";
export const REMOVE_ALL_FROM_STAFF_CART = "REMOVE_ALL_FROM_STAFF_CART";
export const CLEAR_STAFF_CART = "CLEAR_STAFF_CART";
export const CALCULATE_PRICES_STAFF_CART = "CALCULATE_PRICES_STAFF_CART";

/* -------------------------- REPORT FILTERS ------------------------- */
export const SET_REPORT_FILTERS = "SET_REPORT_FILTERS";
export const UPDATE_REPORT_FILTER = "UPDATE_REPORT_FILTER";
export const RESET_REPORT_FILTERS = "RESET_REPORT_FILTERS";

